import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Avatar, Box, Drawer, Link, Typography } from '@mui/material';
// mock
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
//
import navConfig from './NavConfig';
import { get } from 'lodash';
import { getUserLevel } from '../../axiosLib/services/institution/user';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();

  const [userData, setUserData] = useState({});

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    getUserLevel((error, data) => {
      if (!error) {
        setUserData(get(data, 'user'));
      } else {
        console.log(error);
      }
    });
  }, []);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 1, mx: 2.5,}}>
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle>
            <Avatar
              src={'https://ui-avatars.com/api/?name=' + get(userData, 'username', 'R') + '&size=128'}
              alt="photoURL"
            />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {get(userData, 'username', '').substring(0, 15)}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {<strong>Phone: </strong>}{get(userData, 'phone', '').substring(0, 15)}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {<strong>Roll: </strong>}{get(userData, 'roll', '').substring(0, 15)}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>

      <Box sx={{ mb: 1, mx: 2.5 }}>
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle>
            <Box sx={{ ml: 2 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {<strong>Institution Details:</strong>}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {<strong>Name: </strong>} {get(userData, 'institutionId.institutionName', '')}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {<strong>Address: </strong>}{get(userData, 'institutionId.address', '').replaceAll('$$$', ' ')}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {<strong>Phone: </strong>}{get(userData, 'institutionId.mobile', '').replaceAll('$$$', ' ')}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>

      <NavSection navConfig={navConfig} />

      <Box sx={{ flexGrow: 1 }} />

      
    </Scrollbar>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
